import React from 'react'

export default function GetinTouch() {
  return (
    <section className="get-touch-area-2">
    <div className="container">
      <div className="row align-items-center gy-md-0 gy-4">
        <div className="col-md-6">
          <h1>Get your own personal consultation</h1>
          <p>
            Our financial consultants will help you choose the best investment
          </p>
          <div className="consult-num">
            <div>
              <h1>7,000+</h1>
              <p>Total Customers</p>
            </div>
            <div>
              <h1>40+</h1>
              <p>Financial Consultants</p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="touch-form">
            <h3>Get in touch</h3>
            <form action="#">
              <input
                className="form-control"
                type="text"
                placeholder="Enter full name"
                required=""
              />
              <input
                className="form-control"
                type="email"
                placeholder="Enter email address"
                required=""
              />
              <button type="submit" className="theme-btn mt-10">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  )
}
